module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/temp/temp.component.less
// module id = ./src/app/shared/temp/temp.component.less
// module chunks = main